// サーバー側の URI::MailTo::EMAIL_REGEXP と同じ判定にする (MINERVA-2F5)
const EMAIL_REGEXP =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const isValidEmail = (value: string): boolean => EMAIL_REGEXP.test(value.trim());
